declare const __IFRAME_URL__: string
declare const __VERSION__: string
declare const __MANIFEST_URL__: string
declare const __BASE_URL__: string

export const iframeUrl = __IFRAME_URL__ || 'https://ecom.acimacredit.com'
export const sdkVersion = __VERSION__ || ''
export const manifestUrl = __MANIFEST_URL__ || ''
export const baseUrl = __BASE_URL__ || ''
